import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import AOS from "aos";
import "aos/dist/aos.css";
import IMAGES from "../../../constant/IMAGES";
import TextHeader from "../../TextHeader";
import { postAdviseForm } from "../../../service";
import Notify from "../../Notify";
import { Slide, toast, ToastContainer } from "react-toastify";
import CustomCloseButton from "../../CustomCloseButton";
import { Stack } from "@chakra-ui/react";
import Loading from "../../Loading";

const initialValues = {
  name: "",
  phone: "",
  message: "",
};

const SectionContact = () => {
  const [loading, setLoading] = useState(false);
  const formSchema = Yup.object().shape({
    name: Yup.string().required("Vui lòng nhập tên"),
    phone: Yup.string()
      .required("Vui lòng nhập số điện thoại")
      .matches(/^(0|\+84|84)[3-9][0-9]{8}$/, "Số điện thoại không hợp lệ"),
    message: Yup.string().required("Vui lòng nhập nội dung"),
  });
  const renderTextError = (touched: any, errors: any) => {
    return (
      <>
        {touched && errors && (
          <div className="pl-[10px] font-medium text-red-500 whitespace-nowrap">
            {errors}
          </div>
        )}
      </>
    );
  };
  const handleSubmitForm = async (values: any, resetForm: any) => {
    const formattedPhone = values.phone.startsWith("0")
      ? values.phone.replace(/^0/, "84")
      : values.phone;
    try {
      setLoading(true);
      const res = await postAdviseForm(
        values.name,
        formattedPhone,
        values.message
      );

      console.log(res, "ress");
      if (res) {
        toast(<Notify />, {
          closeButton: true,
          className:
            "h-[118px] w-[300px] md:w-[524px] items-center bg-[#0E2411] bg-bgNotiSuss bg-no-repeat bg-cover px-3 md:px-8 p-8 rounded-[12px] border-[1px] border-[#30D158] shadow-[0px_8px_8px_-4px_#1018280A]",
          ariaLabel: "Lưu thông báo thất bại",
        });
      }
    } catch (e: any) {
      if (
        e?.response?.data?.message ===
        "order_with_phone_number_is_still_in_progress"
      ) {
        toast(<Notify />, {
          closeButton: true,
          className:
            "h-[118px] w-[300px] md:w-[524px] items-center bg-[#0E2411] bg-bgNotiSuss bg-no-repeat bg-cover px-3 md:px-8 p-8 rounded-[12px] border-[1px] border-[#30D158] shadow-[0px_8px_8px_-4px_#1018280A]",
          ariaLabel: "Lưu thông báo thất bại",
        });
      } else {
        toast(
          <Notify
            err={true}
            title="Gửi yêu cầu thất bại"
            decs="Vui lòng kiểm tra lại."
          />,
          {
            closeButton: true,
            className:
              "h-[118px] w-[300px] md:w-[524px] items-center bg-[#0E2411] bg-bgNotiErr bg-no-repeat bg-cover px-3 md:px-8 p-8 rounded-[12px] border-[1px] border-[#FF453A] shadow-[0px_8px_8px_-4px_#1018280A]",
            ariaLabel: "Lưu thông báo thất bại",
          }
        );
      }
    } finally {
      setLoading(false);
      resetForm();
    }
  };

  return (
    <div
      className="flex flex-col gap-8 xl:gap-16 xl:scroll-m-52 scroll-m-32 mb-10"
      id="lien-he"
      data-aos="fade-up"
    >
      <TextHeader text="LIÊN HỆ" />
      <div
        className="bg-contactBg bg-no-repeat bg-cover w-full aspect-[1597/773] rounded-[24px] xl:rounded-[45px] px-[7%] py-[5%] relative"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <Formik
          enableReinitialize={true}
          validationSchema={formSchema}
          initialValues={initialValues}
          onSubmit={(values, { resetForm }) =>
            handleSubmitForm(values, resetForm)
          }
        >
          {({
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            setFieldValue,
          }) => {
            return (
              <Form style={{ width: "100%" }} onSubmit={handleSubmit}>
                <div
                  className="w-full xl:w-1/3 flex flex-col gap-[20px]"
                  data-aos="fade-right"
                  data-aos-delay="400"
                >
                  <div className="flex flex-col gap-6">
                    <p className="text-[#FFF8C2] font-bold text-lg xl:text-2xl">
                      Họ và tên
                    </p>
                    <div className="flex flex-col gap-2">
                      <div className="gradient-borderYellow before:p-[1px] rounded-[4px] overflow-hidden h-[64px]">
                        <input
                          name="name"
                          onChange={handleChange("name")}
                          className="bg-[#00000099] w-full h-full contact relative px-4 z-[2] mix-blend-overlay text-white placeholder:text-[#8C8C8C]  "
                          placeholder="Nhập tên"
                          value={values.name}
                        />
                      </div>
                      {renderTextError(touched.name, errors.name)}
                    </div>
                  </div>

                  <div className="flex flex-col gap-6">
                    <p className="text-[#FFF8C2] font-bold text-lg xl:text-2xl">
                      Số điện thoại
                    </p>
                    <div className="flex flex-col gap-2">
                      <div className="gradient-borderYellow before:p-[1px] rounded-[4px] overflow-hidden h-[64px]">
                        <input
                          type="tel"
                          name="phone"
                          onChange={handleChange("phone")}
                          className="bg-[#00000099] w-full h-full contact relative px-4 z-[2] mix-blend-overlay text-white  placeholder:text-[#8C8C8C]"
                          placeholder="Nhập số điện thoại"
                          value={values.phone}
                        />
                      </div>
                      {renderTextError(touched.phone, errors.phone)}
                    </div>
                  </div>
                  <div className="flex flex-col gap-6">
                    <p className="text-[#FFF8C2] font-bold text-lg xl:text-2xl">
                      Lời nhắn
                    </p>
                    <div className="flex flex-col gap-2">
                      <div className="gradient-borderYellow before:p-[1px] rounded-[4px] overflow-hidden h-[243px] xl:h-auto aspect-[765/243]">
                        <textarea
                          name="message"
                          onChange={handleChange("message")}
                          className="bg-[#00000099] w-full h-full contact relative z-[2] p-4 mix-blend-overlay text-white  placeholder:text-[#8C8C8C] "
                          placeholder="Nhập nội dung"
                          value={values.message}
                        />
                      </div>
                      {renderTextError(touched.message, errors.message)}
                    </div>
                  </div>

                  <Stack
                    transition="all 235ms ease-in-out"
                    cursor="pointer"
                    _hover={{
                      transform: "translate3d(0, 2px, 0)",
                    }}
                  >
                    <button
                      type="submit"
                      className="gradient-borderFull cursor-pointer w-fit px-[80px] mt-5 py-1 rounded-full text-goldGradient font-bold text-[24px]"
                    >
                      GỬI
                    </button>
                  </Stack>
                </div>
              </Form>
            );
          }}
        </Formik>
        <img
          src={IMAGES.tenLua}
          alt="tenlua"
          className="absolute hidden xl:block top-1/2 -translate-y-1/2 right-10 animate-slideDownAndUpContact duration-100 delay-300"
        />
      </div>
      {loading && <Loading />}
    </div>
  );
};

export default SectionContact;
